import { useMemo } from "react";
import { useContentful } from "react-contentful";
import { getAssetURL } from "../utils/getAssetURL";
import {
  CLEANSERS,
  EYE_CREAMS,
  MASQUES,
  EXFOLIATORS,
  LIP_CARE,
  MOISTURIZERS,
  SUNCARE,
  SERUM,
  PEELS,
} from "../constants/mainSiteNavigation";
import { getUser, isProLoggedIn, isRetailLoggedIn } from "../utils/jwt";

const useProductsMenu = () => {
  const isRetail = isRetailLoggedIn();
  const isPro = isProLoggedIn();
  const { tier } = getUser() || {};

  const { data, loading, error, fetched } = useContentful({
    contentType: "productsPage",
  });

  const productsMenu = useMemo(() => {
    const { fields } = data?.items?.[0] || {};
    const productDropdownMenu = [
      {
        title: CLEANSERS,
        media: getAssetURL(data, fields?.cleansersMenuImage?.sys?.id),
        filter: "Cleanser",
      },
      {
        title: EXFOLIATORS,
        media: getAssetURL(data, fields?.exfoliatorsMenuImage?.sys?.id),
        filter: "Exfoliator",
      },
      {
        title: MASQUES,
        media: getAssetURL(data, fields?.masquesMenuImage?.sys?.id),
        filter: "Masque",
      },
      {
        title: SERUM,
        media: getAssetURL(data, fields?.serumMenuImage?.sys?.id),
        filter: "Serum",
      },
      {
        title: EYE_CREAMS,
        media: getAssetURL(data, fields?.eyeCreamsMenuImage?.sys?.id),
        filter: "Eye Cream",
      },
      {
        title: LIP_CARE,
        media: getAssetURL(data, fields?.lipCareMenuImage?.sys?.id),
        filter: "Lip Care",
      },

      {
        title: MOISTURIZERS,
        media: getAssetURL(data, fields?.moisturizersMenuImage?.sys?.id),
        filter: "Moisturizer",
      },
      {
        title: SUNCARE,
        media: getAssetURL(data, fields?.sunCareMenuImage?.sys?.id),
        filter: "Sun Care",
      },
    ];

    const productDropdownMenuRetail = [
      {
        title: "Photo Damage",
        media: getAssetURL(data, fields?.photoDamageMenuImage?.sys?.id),
        filter: "Photo-Damage",
      },
      {
        title: "Aging",
        media: getAssetURL(data, fields?.agingMenuImage?.sys?.id),
        filter: "Aging",
      },
      {
        title: "Dryness",
        media: getAssetURL(data, fields?.drynessMenuImage?.sys?.id),
        filter: "Dryness",
      },
      {
        title: "Post Treatment",
        media: getAssetURL(data, fields?.postTreatmentMenuImage?.sys?.id),
        filter: "Post-Treatment",
      },
      {
        title: "Pigmentation",
        media: getAssetURL(data, fields?.pigmentationMenuImage?.sys?.id),
        filter: "Pigmentation",
      },
      {
        title: "Rosacea",
        media: getAssetURL(data, fields?.rosaceaMenuImage?.sys?.id),
        filter: "Rosacea",
      },

      {
        title: "Pores",
        media: getAssetURL(data, fields?.poresMenuImage?.sys?.id),
        filter: "Pores",
      },
      {
        title: "Acne",
        media: getAssetURL(data, fields?.acneMenuImage?.sys?.id),
        filter: "Acne",
      },
    ];

    const result = {
      productDropdownMenu: isRetail
        ? productDropdownMenuRetail
        : productDropdownMenu,
    };

    if (isPro && (!tier || tier === "Tier 1")) {
      result.productDropdownMenu.push({
        title: PEELS,
        media: getAssetURL(data, fields?.peelsMenuImage?.sys?.id),
        filter: "Peel",
      });
    }

    return { ...result };
  }, [data, isPro, tier, isRetail]);

  return {
    ...productsMenu,
    error,
    fetched,
    loading,
  };
};

export default useProductsMenu;
